import React from 'react';

import PlayerInviteCard from '../../../cards/PlayerInviteCard';
import styles from './playerResultsTab.scss';
import { sportTypeIds } from '../../../../utils/eventConstants';

const PlayerResultsTab = ({
    isActiveSearch,
    isLoading,
    isEndOfSearch,
    isAddingEmail,
    playerResults,
    onPlayerSelected,
    onLoadMoreItems,
    sportTypeId = sportTypeIds.TENNIS,
}) => {
    const handleOnPlayerSelected = (playerId) => {
        onPlayerSelected(playerId);
    };

    const handleOnLoadMoreItems = () => {
        onLoadMoreItems();
    };

    const hasNoResults = playerResults.length === 0 && !isLoading;
    const hasResults = playerResults.length > 0;
    const showLoadMoreButton = !isLoading && !isEndOfSearch;

    return (
        <div>
            {isAddingEmail ? (
                <div className={styles.loadingContainer}>{'To add email address press \'Enter\''}</div>
            ) : (
                hasNoResults && (
                    <div className={styles.loadingContainer}>{`${isActiveSearch ? 'No Matches Found' : ''}`}</div>
                )
            )}
            {(hasResults || isLoading) && (
                <div>
                    {isLoading && (
                        <div className={styles.loadingContainer}><i className="fas fa-circle-notch fa-spin" />Loading...</div>
                    )}
                    {playerResults.map(player => (
                        <div key={player.source.id}>
                            <PlayerInviteCard
                                player={player}
                                isSelectable={true}
                                onPlayerSelected={handleOnPlayerSelected}
                                showRemoveButton={false}
                                sportTypeId={sportTypeId}
                            />
                        </div>
                    ))}
                    {showLoadMoreButton && (
                        <div className={styles.buttonContainer}>
                            <button
                                onClick={handleOnLoadMoreItems}
                                type="button"
                                className="btn btn-primary btn-lg text-uppercase"
                            >
                                Load More Results
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default PlayerResultsTab;
